import { useEffect, useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { empresaService } from '@/services/api';
import { Empresa } from '@/types';

const STORAGE_KEY = 'crm_empresa_superadmin';

/**
 * Superadmin não tem uma empresa fixa (diferente de admin/comum, resolvida via header
 * x-empresa-id no backend) — precisa escolher explicitamente em qual empresa está
 * operando o CRM. Persistido em localStorage pra manter a escolha ao navegar entre as
 * abas do módulo (Negócios/Contas/Contatos, cada uma uma rota própria).
 */
export function useCrmEmpresaAtiva() {
  const { user, empresaAtiva } = useAuth();
  const isSuperAdmin = user?.tipo === 'superadmin';

  const [empresas, setEmpresas] = useState<Empresa[]>([]);
  const [selectedEmpresaId, setSelectedEmpresaIdState] = useState<string>(
    () => (isSuperAdmin ? localStorage.getItem(STORAGE_KEY) || '' : ''),
  );

  useEffect(() => {
    if (!isSuperAdmin) return;
    empresaService.getAll().then((result) => {
      if (result.success) {
        setEmpresas(result.data.filter((e) => e.status === 'ativa' && e.modulos_habilitados?.includes('crm')));
      }
    });
  }, [isSuperAdmin]);

  const setSelectedEmpresaId = (id: string) => {
    setSelectedEmpresaIdState(id);
    localStorage.setItem(STORAGE_KEY, id);
  };

  // Empresa efetivamente em uso: escolha do superadmin, ou a empresa ativa de quem logou.
  const empresaId = isSuperAdmin ? selectedEmpresaId : (empresaAtiva?.id || user?.empresa_id || '');

  return { isSuperAdmin, empresas, selectedEmpresaId, setSelectedEmpresaId, empresaId };
}
